import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Usuario, UsuarioAuth } from '../models/usuario.model';
import { StorageService } from './storage.service';
import { catchError, finalize, map, switchMap, tap } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private OAUTH_URL_GMAUTH = environment.OAUTH_URL_GMAUTH;
  private SERVER_URL = environment.SERVER_USU_URL;
  private CLIENT_ID = environment.CLIENT_ID;
  private CLIENT_SECRET = environment.CLIENT_SECRET;
  private VER_HOME = environment.VER_HOME;
  private LOGIN_IS_HOME = environment.LOGIN_IS_HOME;
  public usuario: Usuario | undefined;
  public usuarios: Usuario[] = [];
  public messageCambioClave: string = '';

  constructor(
    private http: HttpClient,
    private router: Router,
    private storageService: StorageService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    /* if (!this.isLoggedIn() && this.LOGIN_IS_HOME) {
      // no se quiere visualizar tienda antes de logear, sino logeado siempre login
      this.router.navigate(['login']);
    } */
    if (state.url === '/' && this.LOGIN_IS_HOME) {
      // no se quiere home
      this.router.navigate(['login']);
    } else if (state.url === '/' && !this.VER_HOME) {
      // no se quiere home
      this.router.navigate(['tienda']);
    }
    return true;
    // return this.isLoggedIn();
  }

  public isLoggedIn() {
    if (typeof localStorage === 'undefined') {
      return false; // Evita el error en SSR
    }

    const usuario: Usuario = localStorage.getItem('usuario_model')
      ? JSON.parse(localStorage.getItem('usuario_model')!)
      : null;
    const token = localStorage.getItem('ACCESS_TOKEN');

    if (token !== null && usuario && usuario.cli_id !== null) {
      return environment.AUTH_TOKEN ? this.checkToken() : true;
    }
    return false;
  }
  public getToken(): string {
    return localStorage.getItem('ACCESS_TOKEN') != null ? localStorage.getItem('ACCESS_TOKEN')! : '';
  }
  public getRefreshToken(): string {
    return localStorage.getItem('REFRESH_TOKEN') != null ? localStorage.getItem('REFRESH_TOKEN')! : '';
  }

  public checkToken(): boolean {
    if (localStorage.getItem('ACCESS_TOKEN') == null) {
      return false;
    }
    const fechaToken = localStorage.getItem('ACCESS_TOKEN_DATE') != null ? new Date(parseInt(localStorage.getItem('ACCESS_TOKEN_DATE')!, 10)) : null;
    const fechaAhora = new Date();
    const expireTime = localStorage.getItem('REFRESH_TOKEN_EXPIRE') != null ? parseInt(localStorage.getItem('REFRESH_TOKEN_EXPIRE')!, 10) : null;
    if (fechaToken != null && expireTime != null) {
      fechaToken.setTime(fechaToken.getTime() + expireTime * 1000);
    }

    if (fechaToken != null && fechaToken.getTime() < fechaAhora.getTime()) {
      // console.log(fechaToken.toISOString() +  ' CADUCADO');
      return false;
    } else {
      // console.log(fechaToken.toISOString() +  ' DISPONIBLE');
      return true;
    }
    // llamada a null con el token para detectar 401.
    const token = localStorage.getItem('ACCESS_TOKEN');
    this.http.get<Usuario>(environment.SERVER_ADM_URL + '/test', {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      })
    }).subscribe(

    );
  }

  getAccessToken(): Promise<any> {
    if (this.checkToken()) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(localStorage.getItem('ACCESS_TOKEN'));
        }, 1);
      });
    } else {
      return this.renovarTokenPhp();
    }
  }
  public logout() {
    // console.clear();
    this.storageService.removeItem('ACCESS_TOKEN');
    this.storageService.removeItem('ACCESS_TOKEN_DATE');
    this.storageService.removeItem('ACCESS_TOKEN_EXPIRE');
    this.storageService.removeItem('ACCESS_TOKEN_TYPE');
    this.storageService.removeItem('REFRESH_TOKEN');
    this.storageService.removeItem('REFRESH_TOKEN_EXPIRE');
    this.storageService.removeItem('usuario_model');
    this.storageService.removeItem('usuarios_model');
    this.storageService.removeItem('alm_id');
    this.usuario = undefined;
    // this.logoutSession(environment.CLIENT_SECRET, environment.CLIENT_ID, this.storageService.getItem('REFRESH_TOKEN')!);

  }

  private renovarTokenPhp(): Promise<any> {
    // 'https://asg-gemmasales.asg-si.net/slim-gsa-api/index-password.php/token'; <-- TEST
    const url = this.OAUTH_URL_GMAUTH + '/token';

    return this.http.post(url, '')
      .toPromise()
      .then((response: any) => {
        localStorage.setItem('ACCESS_TOKEN', response.access_token);
        localStorage.setItem('ACCESS_TOKEN_EXPIRE', response.expires_in);
        localStorage.setItem('ACCESS_TOKEN_TYPE', response.token_type);
        localStorage.setItem('ACCESS_TOKEN_DATE', Date.now().toString());

        return localStorage.getItem('ACCESS_TOKEN');
      });
  }

  public logToken() {
    const url = this.SERVER_URL + '/token';
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      });
    const usuario: Usuario = localStorage.getItem('usuario_model') != null ? JSON.parse(localStorage.getItem('usuario_model')!) : null;
    const options = { headers };
    // tslint:disable-next-line:prefer-const
    const log: Log = {
      usuw_id: usuario.usuw_id,
      token: localStorage.getItem('ACCESS_TOKEN') ? localStorage.getItem('ACCESS_TOKEN')! : '',
      caducidad: localStorage.getItem('ACCESS_TOKEN_EXPIRE')
    };
    // this.http.post(url, log, options)
    //     .toPromise()
    //     .then((response: any) => {
    //       console.log(response);
    //     });
    return this.http.post(url,
      log, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
        // Authorization: this.SERVER_AUTH
      })
    }).toPromise()
      .then((response: any) => {
        console.log("\nRESPUESTA LOGTOKEN: " + response);
      });
  }

  logoutSession(cs: string, ci: string, refreshToken: string) {
    const url = environment.OAUTH_URL_GMAUTH + '/logout';

    let headers = new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded');

    const body = new HttpParams()
      .set('refresh_token', refreshToken)
      .set('client_id', ci)
      .set('client_secret', cs);

    return this.http.post(url, body.toString(), { headers }).subscribe();
  }

  renuevaToken(cs: string, ci: string, refreshToken: string): Observable<UsuarioAuth> {
    const url = environment.OAUTH_URL_GMAUTH + '/token';
    let headers = new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded');
    const body = new HttpParams()
      .set('refresh_token', refreshToken)
      .set('grant_type', 'refresh_token')
      .set('username', localStorage.getItem('usuario') != null ? localStorage.getItem('usuario')! : 'null')
      .set('client_id', ci)
      .set('client_secret', cs);

    return this.http.post<UsuarioAuth>(url, body.toString(), { headers });

  }

  getTokenApp(ci: string, clave: string, usuario: string) {
    const url = environment.OAUTH_URL_GMAUTH_ADMIN;
    const tokenCompleto: string[] = Array(6).fill('');
    let headers = new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded');

    const body = new HttpParams()
      .set('client_id', ci)
      .set('grant_type', 'password')
      .set('password', clave)
      .set('username', usuario);

    return this.http.post<UsuarioAuth>(url, body.toString(), { headers });
  }

}
interface Log {
  usuw_id: number;
  token: string;
  caducidad: string | null;
}
